<template>
  <div v-if="!hasPoints" class="an-empty">
    <i class="fa fa-line-chart"></i>
    <span>Точек для графика нет</span>
  </div>
  <apexchart v-else type="line" height="300" :key="'ts' + (isDark ? 'd' : 'l')"
             :options="options" :series="chartSeries"/>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {formatAxisPoint, formatValue} from "@/common/viewFormat";

// Палитра RumOverview: проверена на различимость при дальтонизме.
// Ряд прошлого периода — серый пунктир: фон для сравнения, а не ещё одна линия.
const COLORS = {
  light: ['#7366ff', '#199e70', '#d95926'],
  dark: ['#7366ff', '#1baf7a', '#d95926'],
}
const PREV_COLOR = {light: '#a3abbd', dark: '#5f6b7d'}

export default {
  name: "ViewTimeseries",
  components: {apexchart: VueApexCharts},
  props: {
    series: {type: Object, required: true},
    isDark: {type: Boolean, default: false},
  },
  computed: {
    rows() {
      return this.series.series || []
    },
    hasPoints() {
      return (this.series.x || []).length > 0 && this.rows.some(r => (r.values || []).some(v => v))
    },
    chartSeries() {
      return this.rows.map(r => ({name: r.label, data: r.values || []}))
    },
    colors() {
      const theme = this.isDark ? 'dark' : 'light'
      let i = 0
      return this.rows.map(r => r.prev ? PREV_COLOR[theme] : COLORS[theme][i++ % COLORS[theme].length])
    },
    options() {
      const text = this.isDark ? '#98a6ad' : '#7b8496'
      const points = (this.series.x || []).length
      return {
        chart: {toolbar: {show: false}, zoom: {enabled: false}, background: 'transparent', fontFamily: 'inherit'},
        theme: {mode: this.isDark ? 'dark' : 'light'},
        colors: this.colors,
        // Без сглаживания: плавная кривая рисовала бы тренд, которого в данных нет.
        stroke: {curve: 'straight', width: this.rows.map(r => r.prev ? 1.5 : 2), dashArray: this.rows.map(r => r.prev ? 5 : 0)},
        markers: {size: points <= 31 ? 3 : 0, strokeWidth: 0},
        grid: {borderColor: this.isDark ? '#374558' : '#e7eaf3'},
        // Ось категорий, а не времени: подписи приходят готовыми днями или
        // часами, и ApexCharts не повторяет одну дату по всей оси.
        xaxis: {
          type: 'category',
          categories: (this.series.x || []).map(formatAxisPoint),
          tickAmount: Math.min(points, 12),
          labels: {rotate: 0, hideOverlappingLabels: true, style: {colors: text}},
        },
        yaxis: {min: 0, labels: {formatter: v => formatValue(v), style: {colors: text}}},
        legend: {labels: {colors: text}},
        tooltip: {shared: true, intersect: false, theme: this.isDark ? 'dark' : 'light', y: {formatter: v => formatValue(v)}},
      }
    },
  },
}
</script>
